import { DtDefault } from '@ow/ditto-core'

const { transformer } = DtDefault
export { default as Render } from './render'
// export { default as transformer } from './transformer'
export { transformer }
